import { lazy } from 'react';

export const ShopPage = lazy(() => import('./ShopPage'));
export const ShopSettingsPage = lazy(() => import('./ShopSettingsPage'));
